'use client';

import { createContext, ReactNode, useContext } from 'react';
import useEmblaCarousel, { EmblaViewportRefType } from 'embla-carousel-react';
import { EmblaCarouselType } from 'embla-carousel';

type CarouselContextType = {
  emblaRef: EmblaViewportRefType;
  emblaApi: EmblaCarouselType | undefined;
};
const CarouselContext = createContext<CarouselContextType | null>(null);

export const useCarouselContext = () => {
  const context = useContext(CarouselContext);
  if (!context)
    throw new Error('useCarouselContext must be used within CarouselProvider');
  return context;
};

export const CarouselProvider = ({ children }: { children: ReactNode }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    dragFree: true,
    align: 'start',
  });

  return (
    <CarouselContext.Provider value={{ emblaRef, emblaApi }}>
      {children}
    </CarouselContext.Provider>
  );
};
